import { Td } from 'components/Td/Td'
import { CircleButton } from 'pages/Shifts/Shifts.styled'
import { darkTheme, Flex, lightTheme, ProfilePicture, Table, TableWrapper, Th, Tr } from 'styling/GlobalStyles'
import { addZero, areDatesSameDay, convertMinsToHrsMins, dateToMinutesUTC } from 'utils/helpers'
import { v4 } from 'uuid'
import { BodyText, OtherText, ParagraphText } from 'styling/Typography'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AttendanceOption, AttendanceOptionsWrapper, AttendanceWeeklyCard } from './Attendance.styled'
import Avatar from '../../assets/images/profileAvatar.png'
import { IAttendanceWorkScheduleInfo, IGetAllAttendanceSingleResponse } from 'types/api/attendanceApi.interface'
import { attendanceTypesOptions, attendanceTypesOptionsWithTime } from './data'
import { AppDispatch, RootState } from 'store'
import { clearAttendances, createAttendance, createMultipleAttendance, deleteAttendance, getAttendances } from 'features/attendance/attendanceSlice'
import useQueryPagination from 'hooks/useQueryPagination'

export const WeeklyDisplay = ({ params, attendance, setModal }: { params: any, attendance: IGetAllAttendanceSingleResponse[], setModal: any }) => {
    const [checked, setChecked] = useState([])
    const { darkMode } = useSelector((store: RootState) => store.globals)
    const [openDropdown, setOpenDropdown] = useState<{ userId: number, day: number } | null>(null)
    const dispatch = useDispatch<AppDispatch>()
    useQueryPagination({ fetchFunctions: [getAttendances], cleanUpFunctions: [clearAttendances], params, otherFunctions: [() => setChecked([])], dontFetchIfEmpty: ['dateTo', 'dateFrom'] })

    const getHeaderDays = () => {
        const arr = []
        const day = new Date(params.dateFrom)
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

        for (let i = 1; i <= 7; i++) {
            const currentDay = `${days[day.getDay()]} ${addZero(day.getDate())}. ${addZero(
                day.getMonth() + 1,
            )}.`
            arr.push(<Td w='10%' noTooltip key={v4()} text={currentDay} />)

            day.setDate(day.getDate() + 1)
        }

        return arr
    }

    const renderAttendanceInputs = (dates: IAttendanceWorkScheduleInfo[], userId: number, userName: string, up: boolean) => {
        const arr = []
        const day = new Date(params.dateFrom)
        for (let i = 1; i <= 7; i++) {
            const currentDayDate = new Date(day) // Create a copy for this iteration
            const attendanceForTheDay: IAttendanceWorkScheduleInfo = dates.find((dt) => {
                return new Date(dt.date).getTime() === currentDayDate.getTime()
            })
            const handleDropdown = () => {
                if (openDropdown && openDropdown.userId === userId && openDropdown.day === i) {
                    setOpenDropdown(null)
                } else {
                    setOpenDropdown({ userId, day: i })
                }
            }

            const { color, label } = attendanceTypesOptions.find(o => o.value == attendanceForTheDay?.workScheduleAttendanceInfo?.type) || { color: '#636363', label: 'Not Set' }
            const hasAttendance = !!attendanceForTheDay?.workScheduleAttendanceInfo?.type
            const handleAttendance = async (a: { label: string, value: number, color: string }, dayDate: Date, id?: number) => {


                if (id) {
                    await dispatch(deleteAttendance({ id, userId }))
                    return
                }

                const currentDate = new Date(Date.UTC(dayDate.getFullYear(), dayDate.getMonth(), dayDate.getDate(), 0, 0, 0, 0))
                const obj: any = {
                    id: attendanceForTheDay?.workScheduleAttendanceInfo?.id || null,
                    userId,
                    attendanceType: a,
                    checkIn: hasAttendance ? dateToMinutesUTC(attendanceForTheDay?.workScheduleAttendanceInfo.startDate) : attendanceForTheDay?.workSchedule?.shift?.shiftStart || null,
                    checkOut: hasAttendance ? dateToMinutesUTC(attendanceForTheDay.workScheduleAttendanceInfo.endDate) : (attendanceForTheDay?.workSchedule?.shift?.minutes ? attendanceForTheDay?.workSchedule?.shift?.minutes + attendanceForTheDay?.workSchedule?.shift?.shiftStart : null),
                    offset: attendanceForTheDay?.workScheduleAttendanceInfo?.offset || null,
                    offsetType: attendanceForTheDay?.workScheduleAttendanceInfo?.offsetType || null,
                    shiftId: attendanceForTheDay?.workSchedule?.id || null,
                    shiftName: attendanceForTheDay?.workSchedule?.shift?.name || null,
                    userName: userName,
                    date: currentDate
                }

                if (a.label.includes('(time input)') || (!attendanceForTheDay?.workSchedule?.id && [1, 4, 8, 11].includes(a.value))) {
                    if (a.value === 11) {
                        obj.attendanceType = attendanceTypesOptions.find(at => at.value == 11)
                    } else {
                        obj.attendanceType = attendanceTypesOptions.find(at => at.value == Number(a.value.toString().split('')[0]))
                    }
                    setModal({
                        open: true, value: { ...obj, userIds: checked }
                    })
                } else {
                    if (checked.length) {
                        delete obj.shiftName
                        delete obj.userName
                        if ([1, 4, 8, 111, 444, 888, 11].includes(a.value)) {
                            obj.checked = checked
                            if (a.value === 11) {
                                obj.attendanceType = attendanceTypesOptions.find(at => at.value == 11)
                            }
                            if (a.label.includes('(time input)')) {
                                obj.attendanceType = attendanceTypesOptions.find(at => at.value == Number(a.value.toString().split('')[0]))
                            }
                            obj.workScheduleIds = attendance.filter(at => checked.includes(at.id)).map(at => at.workScheduleInfos.find(i => areDatesSameDay(i.date, currentDate))?.workSchedule?.id).filter(s => s),
                                setModal({
                                    open: true, value: obj
                                })
                        } else {
                            await dispatch(createMultipleAttendance({
                                userIds: checked,
                                workScheduleIds: attendance.filter(at => checked.includes(at.id)).map(at => at.workScheduleInfos.find(i => areDatesSameDay(i.date, currentDate))?.workSchedule?.id).filter(s => s),
                                startDate: currentDate.toISOString(),
                                endDate: null,
                                type: a.value
                            }))
                        }
                    } else {
                        await dispatch(createAttendance(obj))
                    }
                }
                setOpenDropdown(null)
            }


            arr.push(
                <Td h='100%' w='10%' key={userId + '-' + i} noTooltip>
                    <AttendanceWeeklyCard style={attendanceForTheDay?.workSchedule ? { justifyContent: 'space-between' } : { justifyContent: 'center' }} color={((new Date(attendanceForTheDay?.date) < new Date()) && attendanceForTheDay?.workSchedule && !attendanceForTheDay.workScheduleAttendanceInfo && !attendanceForTheDay?.workSchedule.shift.absence) ? (darkMode ? lightTheme['presentColor'] : darkTheme['presentColor']) : darkMode ? lightTheme[color] : darkTheme[color]} tabIndex={1} onBlur={() => setOpenDropdown(null)} onClick={handleDropdown} >
                        <BodyText
                            style={{
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                maxWidth: '100%',
                            }}
                            color={hasAttendance ? 'black' : 'white'} weight='bold' >{(hasAttendance ? label : attendanceForTheDay?.workSchedule?.shift?.name || 'Not Set')}</BodyText>
                        {attendanceForTheDay?.workSchedule && <Flex column between width='100%' >
                            <ParagraphText style={attendanceForTheDay?.workScheduleAttendanceInfo?.offset ? { lineHeight: 1 } : {}} color={hasAttendance ? 'black' : 'white'} >{convertMinsToHrsMins(attendanceForTheDay.workSchedule.shift.shiftStart)}-{convertMinsToHrsMins(attendanceForTheDay.workSchedule.shift.minutes, attendanceForTheDay.workSchedule.shift.shiftStart)}</ParagraphText>
                            {attendanceForTheDay?.workScheduleAttendanceInfo?.offset && <ParagraphText weight='bold' color={attendanceForTheDay.workScheduleAttendanceInfo.offsetType == 2 ? 'red' : hasAttendance ? 'black' : 'white'}  > {attendanceForTheDay?.workScheduleAttendanceInfo?.offsetType == 2 ? '-' : '+'} {convertMinsToHrsMins(attendanceForTheDay.workScheduleAttendanceInfo.offset)}</ParagraphText>}
                        </Flex>}
                        {openDropdown && openDropdown.userId === userId && openDropdown.day === i && (
                            <AttendanceOptionsWrapper up={up} right={day.getDate() >= 5} >
                                {attendanceForTheDay?.workScheduleAttendanceInfo && <AttendanceOption onClick={() => handleAttendance(null, null, attendanceForTheDay?.workScheduleAttendanceInfo.id)} >
                                    <OtherText color='red' >Remove Attendance</OtherText>
                                </AttendanceOption>}
                                {attendanceTypesOptionsWithTime.filter(a => attendanceForTheDay?.workSchedule?.shift?.absence ? ![1, 4, 8, 1].includes(a.value) : true).map(a => <AttendanceOption onClick={() => handleAttendance(a, currentDayDate)} key={a.value}><OtherText>{a.label}</OtherText></AttendanceOption>)}
                            </AttendanceOptionsWrapper>
                        )}
                    </AttendanceWeeklyCard>
                </Td >,
            )
            day.setDate(day.getDate() + 1)
        }

        return arr
    }

    const toggleAll = () => {
        if (checked.length < attendance.length) {
            for (const a of attendance) {
                const id = a.id

                if (!checked.includes(id)) {
                    setChecked((prev) => [...prev, id])
                }
            }
        } else {
            setChecked([])
        }
    }


    const toggle = (id: number) => {
        if (checked.includes(id)) {
            setChecked((prev) => {
                return prev.filter((item) => item !== id)
            })
        } else {
            setChecked((prev) => (!prev ? [id] : [...prev, id]))
        }
    }


    return <>
        <TableWrapper style={{ width: '100%' }} >
            <Table >
                <Th>
                    <Td w='3%' noTooltip>
                        <CircleButton
                            onClick={toggleAll}
                            checked={checked.length === attendance?.length}
                        />
                    </Td>
                    <Td w='27%' text='Employee' noTooltip />
                    {getHeaderDays()}
                </Th>
                {attendance &&
                    attendance.map((item, i) => {
                        const id = item.id
                        return (
                            <Tr big smallPadding key={id}>
                                <Td noTooltip w='30%'>
                                    <Flex center gap='1rem'>
                                        <CircleButton
                                            orange
                                            checked={checked.includes(id)}
                                            onClick={() => toggle(id)}
                                        />
                                        <ProfilePicture>
                                            <img
                                                src={item.profileImageUrl || Avatar}
                                                alt=''
                                                onError={({ currentTarget }) => {
                                                    currentTarget.onerror = null
                                                    currentTarget.src = Avatar
                                                }}
                                            />
                                        </ProfilePicture>
                                        <BodyText>{item.firstName + ' ' + item.lastName}</BodyText>
                                    </Flex>
                                </Td>
                                {renderAttendanceInputs(item.workScheduleInfos, item.id, (item.firstName + ' ' + item.lastName), (attendance.length > 5) && (i >= attendance.length - 5))}
                            </Tr>
                        )
                    })}
            </Table>
        </TableWrapper>
    </>
}